export default __webpack_public_path__ + "static/media/feature_3.5fe9db52.jpg";